define('GameDayCore/GDModel/enums/baseball/PitchColors',{
    pitchColors: {
        CH: "  0,  85, 254",
        CU: "  0,  34, 255",
        FA: "186,   1,   0",
        FT: "187,   0,  69",
        FF: "188,   0,  33",
        FC: "152,   0, 101",
        FS: "119,   0, 152",
        FO: " 85,   0, 187",
        GY: "  0, 153, 171",
        IN: "135, 136, 154",
        KC: "153, 171,   0",
        KN: "  0, 119, 255",
        NP: "153, 171,   0",
        SC: "153, 171,   0",
        SI: " 50,   0, 221",
        SL: "  0,   0, 254",
        SN: "153, 171,   0",
        PO: "135, 136, 154",
        AB: "153, 171,   0",
        AS: "153, 171,   0",
        EP: "153, 171,   0",
        UN: "50, 50,   50"  // look up
    },
    pitchBallColors: {
        S: "170, 21, 11",
        B: "39, 161, 39",
        X: "26, 86, 190"
    }
});

